import { Supplier } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllSupplier from "@/v2/api/supplier/FindAll";

export function SupplierComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelectedSupplier,
    defaultValueId,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelectedSupplier?: (value: Supplier | null) => void;
    defaultValueId?: string;
    defaultValue: Supplier | null;
}) {
    return (
        <ArFormCombobox<T, Supplier>
            defaultValueId={defaultValueId}
            defaultValue={defaultValue}
            name={name}
            label="Select Supplier"
            queryKey="suppliers"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllSupplier({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(supplier) => supplier.full_name}
            renderItem={(supplier) => (
                <div className="flex flex-col">
                    <span>{supplier.full_name}</span>
                    {supplier.short_code && (
                        <span className="text-xs text-muted-foreground">
                            {supplier.short_code}
                        </span>
                    )}
                </div>
            )}
            placeholder="Select supplier..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(supplier: Supplier | null) => {
                setSelectedSupplier && setSelectedSupplier(supplier);
            }}
        />
    );
}
